import React from 'react';
import { AsyncJsmCmpProjectSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-jsm-cmp-project-settings';
import { AsyncJsmTmpProjectSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-jsm-tmp-project-settings';

type Props = {
	// passed not to send an extra fetch here (because it's from potentially a different hook)
	project: {
		isSimplified: boolean;
	};
};

export const JsmProjectSettingsSidebarSelector = ({ project }: Props) =>
	project.isSimplified ? (
		<AsyncJsmTmpProjectSettingsSidebar />
	) : (
		<AsyncJsmCmpProjectSettingsSidebar />
	);
